export const theme = {
  colors: {
    // Primary colors
    primary: '#ff6b35',
    primaryLight: '#ff8c61',
    primaryDark: '#e55a2b',

    // Background colors
    background: '#1a1a2e',

    // Text colors
    text: '#f8f8f8',
    textSecondary: '#a0a0a0',

    // UI colors
    border: '#333333',
    borderLight: '#444444',

    // Card colors
    cardBackground: 'rgba(255, 255, 255, 0.05)',
    cardBackgroundHover: 'rgba(255, 255, 255, 0.08)',

    // Status colors
    error: '#ef4444',
  },

  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
  },

  fontWeights: {
    medium: 500,
    semibold: 600,
    bold: 700,
  },

  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '3xl': '4rem',
  },

  radii: {
    sm: '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
    full: '9999px',
  },

  shadows: {
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  },

  breakpoints: {
    sm: '640px',
    md: '768px',
    xl: '1280px',
  },

  transitions: {
    fast: '150ms ease-in-out',
  },
};
